<template>
  <div
    class="page-header header-filter"
    filter-color="black"
  >
    <div
      class="page-header-image"
      style="background-image: url(static/img/background/gillwell-background.jpg);"
    />
    <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-4 ml-auto mr-auto">
            <ValidationObserver ref="form">
              <form @submit.prevent="save">
                <card type="login">
                  <h3
                    slot="header"
                    class="header text-center"
                  >
                    Change Password
                  </h3>
                  <ValidationProvider
                    name="currentPassword"
                    rules="required"
                    v-slot="{ passed, failed }"
                  >
                    <fg-input
                      type="password"
                      :error="failed ? 'The Current Password is required' : null"
                      :has-success="passed"
                      required
                      v-model="currentPassword"
                      label="Current Password"
                      placeholder=""
                    />
                  </ValidationProvider>
                  <ValidationProvider
                    name="password1"
                    rules="required|max:255|min:5"
                    v-slot="{ passed, failed }"
                  >
                    <fg-input
                      type="password"
                      v-model="password1"
                      label="New Password"
                      required
                      :error="failed ? 'The Password field is required' : null"
                      :has-success="passed"
                    />
                  </ValidationProvider>
                  <ValidationProvider
                    name="password2"
                    rules="required|max:255|min:5|confirmed:password1"
                    v-slot="{ passed, failed }"
                  >
                    <fg-input
                      type="password"
                      v-model="password2"
                      label="New Password (Repeat)"
                      required
                      :error="failed ? 'The Password fields must match' : null"
                      :has-success="passed"
                    />
                  </ValidationProvider>
                  <br>
                  <p-button
                    native-type="button"
                    @click="cancel"
                    slot="footer"
                    type="info"
                    round
                    block
                    class="mb-3"
                  >
                    Cancel
                  </p-button>
                  <p-button
                    native-type="submit"
                    slot="footer"
                    type="warning"
                    round
                    block
                    class="mb-3"
                  >
                    Change Password
                  </p-button>
                </card>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/services/api/user'
import { extend } from 'vee-validate'
import { required, max, email, min, confirmed } from 'vee-validate/dist/rules'

extend('required', required)
extend('max', max)
extend('min', min)
extend('email', email)
extend('confirmed', confirmed)

export default {
  name: 'PasswordChange',
  data: function () {
    return {
      currentPassword: null,
      password1: null,
      password2: null,
      errormessage: null
    }
  },

  methods: {
    cancel: function () {
      if (this.$root.courseScouterType === 'Participant') {
        this.$router.push('/Participant/Dashboard')
      } else if (this.$root.courseScouterType === 'Staff') {
        this.$router.push('/Staff/Dashboard')
      }
    },
    save: function () {
      return this.$refs.form.validate().then(res => {
        this.submitForm()
        return res
      })
    },
    submitForm: function () {
      return userApi
        .changePassword(
          this.$root.scouterKey,
          this.currentPassword,
          this.password1
        )
        .then(response => {
          if (response.ResultCode !== 'Success') {
            this.$notify({
              message: response.ResultCode + ': ' + response.ResultMessage,
              icon: 'ti-icon ti-alert',
              type: 'danger',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = response.ResultMessage
          } else {
            this.$notify({
              message: response.ResultCode + ': ' + response.ResultMessage,
              icon: 'nc-icon nc-satisfied',
              type: 'success',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.cancel()
          }
        })
    }
  }
}
</script>
